import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=9abd0e5a&scoped=true"
import script from "./BaseTag.vue?vue&type=script&lang=js"
export * from "./BaseTag.vue?vue&type=script&lang=js"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=9abd0e5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abd0e5a",
  null
  
)

export default component.exports